import NavBar from "./common/Navbar";
import Footer from "./common/Footer";
import Home from "./common/Home";
import React from "react";
import { ChakraProvider } from "@chakra-ui/react";

const App = () => {
	return (
		<ChakraProvider>
			<div className="App antialiased overflow-hidden">
				<NavBar />
				<div className="content pt-11">
					<Home />
				</div>
				<Footer />
			</div>
		</ChakraProvider>
	);
};

export default App;
